export default "__VITE_ASSET__HLkMqog3__"